import Element from './Element.js';

export default class Img extends Element
{
	constructor(parentElement)
	{
		super(parentElement);
		this.element.setAttribute('alt','');
	}

	get tagName()
	{
		return 'img';
	}

	set value(value)
	{
		this.element.src = value ? value : '';
	}
}